<app-buy-thankyou-content
  headline="thank_you_buy_phonenumber_headline"
  content="thank_you_buy_phonenumber_content"
  [showBackrouteButton]="true"
  backrouteButton="thank_you_buy_phonenumber_back_button"
  (openBackrouteEvent)="openBackroute()"
></app-buy-thankyou-content>
